import "core-js/modules/es.array.push.js";
import httpRequest from '@/request/index';
import { ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import { showToast, showFailToast, showLoadingToast, closeToast, showConfirmDialog } from 'vant';
import { useRouter } from "vue-router";
import 'vant/es/dialog/style';
export default {
  setup() {
    const store = useStore();
    const addData = ref({
      name: "",
      tel: "",
      province: "",
      city: "",
      county: "",
      addressDetail: "",
      areaCode: "",
      isDefault: false
    });
    const areaList = ref({});
    const router = useRouter();
    const addid = ref(0);
    const showDel = ref(false);
    const onDelete = () => {
      showConfirmDialog({
        message: '确认删除该地址？',
        theme: 'round-button'
      }).then(() => {
        httpRequest({
          method: "get",
          url: "?file=address&act=del&id=" + addid.value
        }).then(res => {
          if (res.state == 1) {
            showToast({
              message: res.msg,
              onClose: function () {
                router.push("/address");
              }
            });
          } else {
            showFailToast(res.msg);
          }
        });
      }).catch(() => {});
    };
    const onSave = content => {
      httpRequest({
        method: "post",
        url: "?file=address&act=save&id=" + addid.value,
        data: content
      }).then(res => {
        if (res.state == 1) {
          showToast({
            message: res.msg,
            onClose: function () {
              router.push("/address");
            }
          });
        } else {
          showFailToast(res.msg);
        }
      });
    };
    onMounted(async () => {
      await store.dispatch("cklogin").then(() => {
        if (!store.state.isLogin) {
          router.replace("/login");
        }
      });
      httpRequest({
        method: "get",
        url: "?file=address&act=area"
      }).then(res => {
        if (res.state == 1) {
          areaList.value = res.list;
        } else {
          showFailToast(res.msg);
        }
      });
      if (router.currentRoute.value.query.id > 0) {
        showLoadingToast({
          message: '加载中',
          forbidClick: true
        });
        addid.value = router.currentRoute.value.query.id;
        showDel.value = true;
        httpRequest({
          method: "get",
          url: "?file=address&act=edit&id=" + addid.value
        }).then(res => {
          closeToast();
          if (res.state == 1) {
            addData.value = res.info;
          } else {
            showFailToast(res.msg);
          }
        });
      }
    });
    const goBack = () => {
      router.go(-1);
    };
    return {
      addData,
      areaList,
      onDelete,
      onSave,
      showDel,
      goBack
    };
  }
};